import { Injectable } from '@angular/core';

import { OnDemandPublicTrip, Product, RidangoEpic, RidangoReduxAction } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { StopData } from '../ride-planner.model';

import { RidePlannerService } from '../ride-planner.service';
import { RidePlannerActions } from './ride-planner.actions';

@Injectable({
    providedIn: 'root',
})
export class RidePlannerEpics implements RidangoEpic {
    constructor(private actions: RidePlannerActions, private service: RidePlannerService) {}

    register() {
        return [this.fetchEstimatedPrice, this.fetchProducts, this.postBookingFlow, this.fetchPotentialStops, this.fetchFilteredPotentialStops];
    }

    fetchEstimatedPrice = (action$: ActionsObservable<any>) =>
        action$.ofType(RidePlannerActions.FETCH_ESTIMATED_PRICE).pipe(
            switchMap((action: RidangoReduxAction) => {
                const { startDate, coordinates } = action.payload;

                return this.service.fetchEstimatedPrice(startDate, coordinates).pipe(
                    map((d: any) => {
                        const smallestEstimatedPrice = Math.min.apply(
                            Math,
                            d.map(function (item) {
                                return item.price;
                            })
                        );
                        return this.actions.fetchEstimatedPriceSuccess(smallestEstimatedPrice);
                    }),
                    catchError((e) => [this.actions.fetchEstimatedPriceFailed(e)])
                );
            })
        )

    fetchProducts = (action$: ActionsObservable<any>) =>
        action$.ofType(RidePlannerActions.FETCH_PRODUCTS).pipe(
            switchMap(() => {
                return this.service.fetchProducts().pipe(
                    map((d: Product[]) => this.actions.fetchProductsSuccess(d)),
                    catchError((e) => [this.actions.fetchProductsFailed(e)])
                );
            })
        )

    postBookingFlow = (action$: ActionsObservable<any>) =>
        action$.ofType(RidePlannerActions.POST_BOOKING_FLOW).pipe(
            switchMap((action: RidangoReduxAction) => {
                return this.service.postBookingFlow(action.payload).pipe(
                    map((d: any) => this.actions.postBookingFlowSuccess(d)),
                    catchError((e) => [this.actions.postBookingFlowFailed(e)])
                );
            })
        )

    fetchPotentialStops = (action$: ActionsObservable<any>) =>
        action$.ofType(RidePlannerActions.FETCH_POTENTIAL_STOPS).pipe(
            switchMap((action: RidangoReduxAction) => {
                return this.service.fetchPotentialStops().pipe(
                    map((d: StopData[]) => this.actions.fetchPotentialStopsSuccess(d)),
                    catchError((e) => [this.actions.fetchPotentialStopsFailed(e)])
                );
            })
        )

    fetchFilteredPotentialStops = (action$: ActionsObservable<any>) =>
        action$.ofType(RidePlannerActions.FETCH_FILTERED_STOPS).pipe(
            switchMap((action: RidangoReduxAction) => {
                return this.service.fetchFilteredPotentialStops(action.payload).pipe(
                    map((d: StopData[]) => this.actions.fetchFilteredPotentialStopsSuccess(d)),
                    catchError((e) => [this.actions.fetchFilteredPotentialStopsFailed(e)])
                );
            })
        )
}
